// controllers
import { CheckBalance } from '../game-flow/controllers/check-balance';
import { FeatureSpinStop } from '../game-flow/controllers/feature-spin-stop';
import { GameStart } from '../game-flow/controllers/game-start';
import { idle } from '../game-flow/controllers/idle';
import { Launch } from '../game-flow/controllers/launch';
import { Loading } from '../game-flow/controllers/loading';
import { EvFeatureEnter } from '../game-flow/controllers/ev-feature-enter';
import { EvFeatureExit } from '../game-flow/controllers/ev-feature-exit';
import { EvMaxWin } from '../game-flow/controllers/ev-max-win';
import { EvRespin } from '../game-flow/controllers/ev-respin';
import { EvReveal } from '../game-flow/controllers/ev-reveal';
import { EvFsRespin } from '../game-flow/controllers/ev-fs-respin';
import { Preloading } from '../game-flow/controllers/preloader';
import { RoundCompleted } from '../game-flow/controllers/round-completed';
import { RoundFail } from '../game-flow/controllers/round-fail';
import { RoundStart } from '../game-flow/controllers/round-start';
import { ServerFail } from '../game-flow/controllers/server-fail';
import { SpinStart } from '../game-flow/controllers/spin-start';
import { SpinStop } from '../game-flow/controllers/spin-stop';
import { Splash } from '../game-flow/controllers/splash';

// decisions
import { evMaxWinDecision } from '../game-flow/decisions/ev-max-win-decision';
import { evFsRespinDecision } from '../game-flow/decisions/ev-fs-respin-decision';
import { evRevealDecision } from '../game-flow/decisions/ev-reveal-decision';
import { evRespinDecision } from '../game-flow/decisions/ev-respin-decision';

export const controllersConfig = [
    { controller: Launch, to: Preloading, fail: ServerFail, initial: true },
    { controller: Preloading, to: Loading, fail: ServerFail },
    { controller: Loading, to: Splash, fail: ServerFail },
    { controller: Splash, to: GameStart, fail: ServerFail },
    { controller: GameStart, to: idle },
    { controller: idle, to: CheckBalance },
    { controller: CheckBalance, to: SpinStart },
    { controller: SpinStart, to: RoundStart, fail: RoundFail },
    { controller: RoundFail, to: idle },
    { controller: RoundStart, to: SpinStop },
    { controller: SpinStop, to: EvReveal },
    { controller: EvReveal, to: [RoundCompleted, EvFeatureEnter, EvRespin, EvMaxWin], decision: evRevealDecision },
    { controller: RoundCompleted, to: idle },
    { controller: EvRespin, to: [SpinStop, FeatureSpinStop, EvMaxWin], decision: evRespinDecision },
    { controller: EvMaxWin, to: [RoundCompleted, EvFeatureExit ], decision: evMaxWinDecision },
    { controller: EvFeatureEnter, to: EvFsRespin },
    // { controller: FeatureSpinStart, to: FeatureSpinStop },
    // { controller: FeatureSpinStop, to: EvFsRespin },
    { controller: EvFsRespin, to: [EvFsRespin, EvMaxWin, EvFeatureExit], decision: evFsRespinDecision },
    { controller: EvFeatureExit, to: RoundCompleted },
    { controller: ServerFail }
]
